import { RootState } from "../store";

export const selectValidityTypes = (state: RootState) => state.validityTypes.list;
export const selectErrorMessageValidityTypes = (state: RootState) => state.validityTypes.errorMessage;